import { FeatureFlagVariationValue, useFeatureFlag } from '@moda/portal-stanchions';

type AlgoliaRecommendations = {
  'looking-similar': boolean;
};

const isTreatmentValid = (
  treatment: FeatureFlagVariationValue
): treatment is AlgoliaRecommendations =>
  treatment != null &&
  typeof treatment === 'object' &&
  !Array.isArray(treatment) &&
  Object.values(treatment).every(
    value =>
      value != null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      typeof value.collection === 'string' &&
      typeof value.message === 'string'
  );

const DEFAULT_ALGOLIA_RECOMMENDATIONS = {
  'looking-similar': false
};

export const useAlgoliaRecommendations = () => {
  const algoliaRecommendations = useFeatureFlag('algolia-recommendations', [
    {
      default: DEFAULT_ALGOLIA_RECOMMENDATIONS
    },
    {
      getFromTreatment: treatment =>
        isTreatmentValid(treatment) ? treatment : DEFAULT_ALGOLIA_RECOMMENDATIONS
    }
  ]);

  return algoliaRecommendations;
};
